
/**
 * MójKardiolog / Shopify – subscription-cart-fix.js, v3.0
 *
 * 1) Adds the required selling_plan to standard product forms when the
 *    selected variant has exactly one selling plan.
 * 2) Handles /cart/add/{variant} quick-add links for subscription-only items.
 * 3) On /products/kardia-mobile-6l shows an OPTIONAL MójKardiolog+ upsell;
 *    when chosen it submits DEVICE (one-time) + SERVICE (recurring) together.
 *
 * The upsell is NEVER checked automatically. This script does not change
 * existing Appstle contracts or alter the Appstle widget configuration.
 */
(function () {
  'use strict';

  // Avoid registering duplicate handlers if the theme includes the script twice.
  if (window.__mkSubscriptionCartFixV3) return;
  window.__mkSubscriptionCartFixV3 = true;

  const CONFIG = {
deviceHandles: [
  'kardia-mobile-6l',
  'kardia-mobile-arytmia-kobiet-w-ciazy'
],
    subscriptionHandle: 'subskrypcja-mojkardiolog-plus',
    productFormSelector: 'form[action*="/cart/add"]',
    quickAddSelector: 'a[data-id][data-handle][href*="/cart/add/"]'
  };

  const root = (window.Shopify && window.Shopify.routes &&
    window.Shopify.routes.root) || '/';
  const base = root.endsWith('/') ? root : root + '/';
  const productCache = new Map();
  const busyForms = new WeakSet();
  let scanTimer = null;

  function productUrl(handle) {
    return base + 'products/' + encodeURIComponent(handle);
  }

  function getProduct(handle) {
    if (!productCache.has(handle)) {
      const request = fetch(productUrl(handle) + '.js')
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Produkt ' + handle + ': HTTP ' + response.status);
          }
          return response.json();
        })
        .catch(function (error) {
          productCache.delete(handle);
          throw error;
        });
      productCache.set(handle, request);
    }
    return productCache.get(handle);
  }

  function getVariant(product, variantId) {
    return (product.variants || []).find(function (variant) {
      return String(variant.id) === String(variantId);
    });
  }

  function getOnlyPlan(variant) {
    if (!variant || !variant.requires_selling_plan) return null;
    const plans = variant.selling_plan_allocations || [];
    return plans.length === 1 ? plans[0] : null;
  }

  function productHandleFromUrl(rawUrl) {
    try {
      const url = new URL(rawUrl, window.location.href);
      if (url.origin !== window.location.origin) return null;
      const match = url.pathname.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : null;
    } catch (_error) {
      return null;
    }
  }

  function findFormProductHandle(form) {
    const onProductPage = productHandleFromUrl(window.location.href);
    if (onProductPage) return onProductPage;

    // Only inspect a card's nearest container, not the entire product grid.
    let node = form;
    for (let depth = 0; node && depth < 8; depth += 1) {
      const handle = node.getAttribute('data-product-handle') ||
        node.getAttribute('data-handle');
      if (handle) return handle;

      // A shared parent with several product forms cannot identify this item.
      if (node.querySelectorAll(CONFIG.productFormSelector).length > 1) break;
      const link = node.querySelector('a[href*="/products/"]');
      const linkedHandle = link ? productHandleFromUrl(link.href) : null;
      if (linkedHandle) return linkedHandle;
      node = node.parentElement;
    }
    return null;
  }

  function formVariantId(form) {
    const field = form.querySelector('[name="id"]');
    return field ? String(field.value) : null;
  }

  // -----------------------------------------------------------------------
  // A. Standard product forms: subscription-only variants.
  // -----------------------------------------------------------------------
  async function applyRequiredSellingPlan(form) {
    if (!form.isConnected) return;
    const variantId = formVariantId(form);
    if (!variantId) return;

    const handle = findFormProductHandle(form);
    try {
      let product = handle ? await getProduct(handle) : null;
      let variant = product ? getVariant(product, variantId) : null;

      // Safe fallback for the service's variant when LayoutHub hides the handle.
      if (!variant && handle !== CONFIG.subscriptionHandle) {
        product = await getProduct(CONFIG.subscriptionHandle);
        variant = getVariant(product, variantId);
      }
      if (!variant || !form.isConnected || formVariantId(form) !== variantId) return;

      const existing = form.querySelector('[name="selling_plan"]');
      const plan = getOnlyPlan(variant);
      if (!plan) {
        // Remove only the field owned by this script; leave Appstle's own alone.
        if (existing && existing.dataset.mkAutoPlan === 'true') existing.remove();
        return;
      }

      if (existing && existing.dataset.mkAutoPlan !== 'true') {
        // Respect a selection supplied by Appstle or the merchant.
        return;
      }

      let field = existing;
      if (!field) {
        field = document.createElement('input');
        field.type = 'hidden';
        field.name = 'selling_plan';
        field.dataset.mkAutoPlan = 'true';
        form.appendChild(field);
      }
      field.value = String(plan.selling_plan_id);
    } catch (error) {
      console.warn('[MK Subscription] Product-form plan:', error);
    }
  }

  function scanForms() {
    document.querySelectorAll(CONFIG.productFormSelector).forEach(function (form) {
      applyRequiredSellingPlan(form);
    });
  }

  // -----------------------------------------------------------------------
  // B. Native form submission: confirmed compatible with this Shopify store.
  // IMPORTANT: this genuinely adds items to cart and navigates away.
  // -----------------------------------------------------------------------
  function submitNativeItems(items) {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = base + 'cart/add';
    form.style.display = 'none';

    items.forEach(function (item, index) {
      Object.entries(item).forEach(function (entry) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'items[' + index + '][' + entry[0] + ']';
        input.value = String(entry[1]);
        form.appendChild(input);
      });
    });

    document.body.appendChild(form);
    HTMLFormElement.prototype.submit.call(form);
  }

  // Single-item native submission for subscription quick-add links.
  function submitNativeSubscription(variantId, planId) {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = base + 'cart/add';
    form.style.display = 'none';

    const fields = {
      id: variantId,
      quantity: 1,
      selling_plan: planId
    };
    Object.entries(fields).forEach(function (entry) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = entry[0];
      input.value = String(entry[1]);
      form.appendChild(input);
    });

    document.body.appendChild(form);
    HTMLFormElement.prototype.submit.call(form);
  }

  // -----------------------------------------------------------------------
  // C. Collection/home quick-add links.
  // -----------------------------------------------------------------------
  function scanQuickAddLinks() {
    document.querySelectorAll(CONFIG.quickAddSelector).forEach(function (link) {
      const handle = link.dataset.handle;
      const variantId = link.dataset.id;
      const key = handle + ':' + variantId;
      if (link.dataset.subscriptionScanKey === key) return;

      link.dataset.subscriptionScanKey = key;
      getProduct(handle).then(function (product) {
        if (link.dataset.subscriptionScanKey !== key) return;
        const variant = getVariant(product, variantId);
        link.dataset.subscriptionQuickAdd =
          variant && variant.requires_selling_plan ? 'true' : 'false';
      }).catch(function (error) {
        console.warn('[MK Subscription] Quick-add detection:', error);
      });
    });
  }

  window.addEventListener('click', function (event) {
    const target = event.target instanceof Element ? event.target : null;
    const link = target && target.closest(CONFIG.quickAddSelector);
    if (!link || event.button !== 0 || event.ctrlKey || event.metaKey ||
        event.altKey || event.shiftKey) return;

    const handle = link.dataset.handle;
    const variantId = String(link.dataset.id);
    const subscriptionOnly =
      handle === CONFIG.subscriptionHandle ||
      link.dataset.subscriptionQuickAdd === 'true';
    if (!subscriptionOnly) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (link.dataset.mkProcessing === 'true') return;
    link.dataset.mkProcessing = 'true';

    getProduct(handle).then(function (product) {
      const variant = getVariant(product, variantId);
      const plan = getOnlyPlan(variant);
      if (!plan) {
        // Never guess the plan when customer choice is needed.
        window.location.assign(productUrl(handle) + '?variant=' +
          encodeURIComponent(variantId));
        return;
      }
      submitNativeSubscription(variantId, plan.selling_plan_id);
    }).catch(function (error) {
      console.error('[MK Subscription] Quick add failed:', error);
      window.location.assign(productUrl(handle) + '?variant=' +
        encodeURIComponent(variantId));
    }).finally(function () {
      link.dataset.mkProcessing = 'false';
    });
  }, true);

  // -----------------------------------------------------------------------
  // D. Kardia Mobile 6L optional upsell:
  //   DEVICE one-time + MójKardiolog+ subscription (paid from month one).
  // -----------------------------------------------------------------------
const currentProductHandle =
  productHandleFromUrl(window.location.href);

const isDevicePage =
  CONFIG.deviceHandles.includes(currentProductHandle);

  function formatPLN(cents) {
    return new Intl.NumberFormat('pl-PL', {
      style: 'currency',
      currency: 'PLN'
    }).format(cents / 100);
  }

  function showUpsellError(form, message) {
    const element = form.querySelector('[data-mk-subscription-status]');
    if (element) element.textContent = message;
  }

  function injectStyles() {
    if (document.getElementById('mk-subscription-fix-style')) return;
    const style = document.createElement('style');
    style.id = 'mk-subscription-fix-style';
    style.textContent = [
      '.mk-subscription-upsell{box-sizing:border-box;width:100%;flex-basis:100%;margin:16px 0;padding:16px;border:1px solid #d9deed;border-radius:10px;background:#f7f9ff;color:#24304a}',
      '.mk-subscription-upsell label{display:flex;align-items:flex-start;gap:12px;cursor:pointer;line-height:1.45}',
      '.mk-subscription-upsell input[type="checkbox"]{width:20px;height:20px;flex:0 0 20px;margin:2px 0 0;accent-color:#2e3b8f}',
      '.mk-subscription-upsell strong{display:block;font-size:12px}',
      '.mk-subscription-upsell .mk-subscription-price{display:block;margin-top:4px;font-size:14px;font-weight:600}',
      '.mk-subscription-upsell .mk-subscription-terms{margin:10px 0 0 10px;font-size:12px;line-height:1.5;color:#4e5770;text-align:justify;white-space:pre-line}',
      '.mk-subscription-upsell .mk-subscription-status{margin:8px 0 0 32px;font-size:12px;color:#a13225}',
      '.mk-subscription-upsell .mk-subscription-terms a{display:inline-block;margin-top:6px;color:#2e3b8f;font-weight:600;text-decoration:underline}'
    ].join('');
    document.head.appendChild(style);
  }

  function addUpsellToForm(form) {
    if (!isDevicePage || !form.isConnected ||
        form.querySelector('.mk-subscription-upsell')) return;

    injectStyles();
    const panel = document.createElement('div');
    panel.className = 'mk-subscription-upsell';
    panel.setAttribute('data-mk-upsell', '');
    panel.innerHTML =
      '<label>' +
        '<input type="checkbox" data-mk-optin disabled>' +
        '<span><strong>Dodaj opiekę kardiologiczną "MójKardiolog+" i zyskaj 99 zł rabatu na urządzenie!</strong>' +
        '<span class="mk-subscription-price" data-mk-price>Ładowanie ceny subskrypcji…</span></span>' +
      '</label>' +
      '<p class="mk-subscription-terms" data-mk-terms>' +
        'Opcjonalna usługa. Pierwsza opłata przy zakupie, następnie automatycznie co miesiąc. ' +
        'Możliwość rezygnacji zgodnie z warunkami subskrypcji.' +
      '</p>' +
      '<p class="mk-subscription-status" data-mk-subscription-status role="status"></p>';

    const submitControl = form.querySelector(
      'button[type="submit"], input[type="submit"], ' +
      'button[name="add"], [class*="add-to-cart"]'
    );

    // Put it near the buy button, but always INSIDE the real product form.
    if (submitControl && submitControl.parentElement &&
        submitControl.parentElement !== form) {
      submitControl.parentElement.insertAdjacentElement('beforebegin', panel);
    } else if (submitControl) {
      submitControl.insertAdjacentElement('beforebegin', panel);
    } else {
      form.appendChild(panel);
    }

    const checkbox = panel.querySelector('[data-mk-optin]');
    const priceLabel = panel.querySelector('[data-mk-price]');
    const terms = panel.querySelector('[data-mk-terms]');

    getProduct(CONFIG.subscriptionHandle).then(function (product) {
      const eligible = (product.variants || []).filter(function (variant) {
        return variant.requires_selling_plan &&
          (variant.selling_plan_allocations || []).length === 1;
      });
      if (eligible.length !== 1) {
        throw new Error('Nie ma dokładnie jednego kwalifikującego się wariantu subskrypcji.');
      }

      const variant = eligible[0];
      const plan = getOnlyPlan(variant);
      if (!plan) throw new Error('Nie można ustalić planu subskrypcji.');

      panel.dataset.subscriptionVariantId = String(variant.id);
      panel.dataset.subscriptionPlanId = String(plan.selling_plan_id);
      checkbox.disabled = false;
      const price = formatPLN(plan.price);
      priceLabel.textContent = price + ' / miesiąc';
      terms.textContent =
        'Rabat pokrywa koszt pierwszego miesiąca subskrypcji. Kolejne opłaty wynoszą 99 zł miesięcznie (pobierane automatycznie).\n' +
        'Możesz zrezygnować w dowolnym momencie.';
        // Link do opisu subskrypcji
        const link = document.createElement('a');
        link.href = '/products/subskrypcja-mojkardiolog-plus';
        link.textContent = 'Dowiedz się więcej o subskrypcji MójKardiolog+';
        link.target = '_blank';
        link.rel = 'noopener noreferrer';

terms.appendChild(document.createElement('br'));
terms.appendChild(link);

    }).catch(function (error) {
      priceLabel.textContent = 'Opcja chwilowo niedostępna';
      showUpsellError(form, 'Nie udało się wczytać subskrypcji. Odśwież stronę.');
      console.error('[MK Subscription] Upsell unavailable:', error);
    });
  }

  function scanDeviceForms() {
    if (!isDevicePage) return;
    document.querySelectorAll('form.lh-product-form[action*="/cart/add"]')
      .forEach(addUpsellToForm);
  }

  async function addDeviceAndSubscription(form) {
    if (busyForms.has(form)) return;
    busyForms.add(form);

    try {
      const panel = form.querySelector('[data-mk-upsell]');
      const deviceId = formVariantId(form);
      const subscriptionId = panel && panel.dataset.subscriptionVariantId;
      const planId = panel && panel.dataset.subscriptionPlanId;

      if (!deviceId || !subscriptionId || !planId) {
        throw new Error('Nie udało się ustalić wariantów i planu sprzedaży.');
      }

      // Verify that the selected device variant belongs to this product.
      const product = await getProduct(currentProductHandle);
      const deviceVariant = getVariant(product, deviceId);
      if (!deviceVariant || !deviceVariant.available) {
        throw new Error('Wybrany wariant urządzenia nie jest dostępny.');
      }

      const quantityField = form.querySelector('[name="quantity"]');
      const qty = Number(quantityField ? quantityField.value : 1);
      const quantity = Number.isInteger(qty) && qty > 0 ? qty : 1;

      // Subscription quantity remains ONE, even for several devices.
      submitNativeItems([
        { id: deviceId, quantity: quantity },
        { id: subscriptionId, quantity: 1, selling_plan: planId }
      ]);
    } catch (error) {
      busyForms.delete(form);
      showUpsellError(form,
        'Nie udało się dodać zestawu do koszyka. Spróbuj ponownie.');
      console.error('[MK Subscription] Combined purchase failed:', error);
    }
  }

  function selectedUpsellForm(form) {
    if (!isDevicePage || !form ||
        !form.matches('form.lh-product-form[action*="/cart/add"]')) {
      return false;
    }
    const checkbox = form.querySelector('[data-mk-optin]');
    return !!(checkbox && !checkbox.disabled && checkbox.checked);
  }

  // Capture submit before LayoutHub's AJAX submit handlers, ONLY if opted in.
  window.addEventListener('submit', function (event) {
    if (!selectedUpsellForm(event.target)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    addDeviceAndSubscription(event.target);
  }, true);

  // Some LayoutHub themes use a button click handler without form submit.
  window.addEventListener('click', function (event) {
    if (!isDevicePage || event.button !== 0) return;
    const target = event.target instanceof Element ? event.target : null;
    const control = target && target.closest(
      'button, input[type="submit"], a, [role="button"]'
    );
    if (!control) return;

    const form = control.closest('form.lh-product-form[action*="/cart/add"]');
    if (!selectedUpsellForm(form)) return;

    const name = [
      control.className,
      control.getAttribute('aria-label'),
      control.getAttribute('title'),
      control.textContent
    ].join(' ');
    const isPurchaseControl =
      control.getAttribute('type') === 'submit' ||
      (control.tagName === 'BUTTON' && !control.hasAttribute('type')) ||
      /add.?to.?cart|dodaj do koszyka|do koszyka|kup teraz|buy now/i.test(name) ||
      (control.tagName === 'A' && /\/cart\/add/.test(control.href));

    if (!isPurchaseControl) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    addDeviceAndSubscription(form);
  }, true);

  // -----------------------------------------------------------------------
  // E. Initialization and support for content added dynamically by LayoutHub.
  // -----------------------------------------------------------------------
  function scanAll() {
    scanForms();
    scanQuickAddLinks();
    scanDeviceForms();
  }

  function scheduleScan() {
    clearTimeout(scanTimer);
    scanTimer = setTimeout(scanAll, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanAll);
  } else {
    scanAll();
  }

  document.addEventListener('change', function () {
    scheduleScan();
    // Some theme scripts update the selected variant asynchronously.
    setTimeout(scanForms, 300);
  }, true);

  const observer = new MutationObserver(scheduleScan);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  window.addEventListener('pageshow', scheduleScan);
  console.info('[MK Subscription] Global cart fix v3.0 loaded');
})();
